export default __webpack_public_path__ + "static/media/a-icon-globe.dbd84a9a.svg";